import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: notifications.MetaTracker.
export default class TrackingEvent extends Fragment {
  declare [Type]: 'notifications/tracking-event';

  // Unix timestamp of when event occurred
  @attr('number')
  declare timestamp: number | undefined;
}
